import React, { useState, useMemo } from "react";
import { ZustandStore } from "../../../store/zustand-store";
import { useLocation } from "react-router-dom";

import Select from "@semcore/select";
import { ScreenReaderOnly } from "@semcore/flex-box";
import { Flex } from "@semcore/flex-box";
import { useTranslation } from "react-i18next"; 

const BusinessListDropdown = () => {
  const {t} =useTranslation()
  const location = useLocation();
  const { map_project, bussiness_name } = ZustandStore((state) => state);
  const [filter, setFilter] = useState("");

  const userAllProject = map_project?.map((res) => res.Project).flat();
  const businessNameArr = Array.from(
    new Set(userAllProject.map((prnameurl) => prnameurl.bussiness_name))
  );
  const bussinessName = bussiness_name ? bussiness_name : "Add Project";

  const SelectPrName = (e) => {
    if (e === bussiness_name) return;
    sessionStorage.setItem("LAST_MAPPRPJECT_SELECTED", e);
    ZustandStore.setState({
      bussiness_name: e,
      CURRLOCATION: {
        code: "All Locations",
        name: "All Locations",
      },
      mapshowloader: true,
      mapdeviceType: null,
      map_top_rank: {
        data: [],
        top_rank: false,
        type: "",
        competitors: false,
      },
      map_all_loc_data: [],
      map_keyword_latest_data: [],
      map_keyword_old_data: [],
      map_keyword_loc_data: "",

      selected_project_id: null,
      RANKMOVEDUP: 0,
      RANKMOVEDDOWN: 0,
      USERALLPENDINGRESULT: [],
      USERALLKEYWORDRESULT: [],
      RANKKEYWORD: [],
      SELECTEDPROJECTNEWDATA: [],
      USERCOMPATITORS: [],
      PREVIOUSALLOLDDATA: [],
      OLDKEYWORDDATA: [],
      USERCURRENTPROJECTLOCATION: [],
      tag_keywords: [],
      filter_tag: [],
      keyword_tag_data: {
        loaded: false,
        error: false,
        data: [],
      },
    });
  };

  const options = useMemo(
    () =>
      businessNameArr?.filter((value) => {
        return value.toString().toLowerCase().includes(filter.toLowerCase());
      }),
    [filter, businessNameArr]
  );

  return (
    <Flex direction="column">
      <Select
        w="100%"
        value={bussinessName}
        onChange={SelectPrName}
        placeholder={bussinessName}
        disabled={location?.pathname === "/guest/local-tracker"}
      >
        <Select.Trigger
          id="options-filtering-advanced"
          style={{
            width: "100%",
            height: "35px",
          }}
        />
        <Select.Popper aria-label={"Project options with search"}>
        <Select.InputSearch
            value={filter}
            onChange={setFilter}
            aria-describedby={filter ? "search-result" : undefined}
          />
          <Select.List hMax={"224px"}>
            {options.map((value) => (
              <Select.Option
                value={value}
                key={value}
                style={{
                  boxShadow: "none",
                }}
              >
                {value}
              </Select.Option>
            ))}
            {options.length ? (
              <ScreenReaderOnly
                id="search-result-advanced"
                aria-hidden={"true"}
              >
                {options.length}{t("rank_tracking.map_rank_tracker.add_first_project.result")}{options.length > 1 && "s"} {t("rank_tracking.map_rank_tracker.add_first_project.found")}
              </ScreenReaderOnly>
            ) : (
              <Select.Option.Hint id="search-result-advanced" key="Nothing">
                Nothing {t("rank_tracking.map_rank_tracker.add_first_project.title")}
              </Select.Option.Hint>
            )}
          </Select.List>
        </Select.Popper>
      </Select>
    </Flex>
  );
};

export default React.memo(BusinessListDropdown);
